/* eslint-disable import/prefer-default-export */
export const operator = {
    username: '',
    forname: '',
    surname: '',
    mail: '',
    phone: '',
    active: false,
};
